module.exports = __webpack_public_path__ + "static/media/platform.4fb98303.png";